import React from "react";
import PublishersFirstRef from "../../Partials/Reports/PublishersFirstRef";

const ListReportDisPostOffice = () => {
  return (
    <PublishersFirstRef
      dpo
      reportDpoOptions
    />
  );
};

export default ListReportDisPostOffice;
